var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import atomicsMapTransfer from './atomicMap';
import { DivTag, UlTag, LiTag, SpanTag } from '../../Utils/AtomicTag';
import Button from '../Button';
import { ArrowRightOutlined, ArrowLeftOutlined } from '@feb-team/legao-icons-react';
import Checkbox from '../Checkbox';
var Transfer = /** @class */ (function (_super) {
    __extends(Transfer, _super);
    function Transfer(props) {
        var _this = _super.call(this, props) || this;
        _this.splitedDataSource = null;
        _this.splitDataSource = function (props) {
            if (_this.splitedDataSource) {
                return _this.splitedDataSource;
            }
            var data = props.data, targetKeys = props.targetKeys;
            var sourceDataSource = data.filter(function (_a) {
                var key = _a.key;
                return targetKeys.indexOf(key) === -1;
            });
            var targetDataSource = [];
            targetKeys.forEach(function (targetKey) {
                var targetItem = data.filter(function (record) { return record.key === targetKey; })[0];
                if (targetItem) {
                    targetDataSource.push(targetItem);
                }
            });
            _this.splitedDataSource = {
                sourceDataSource: sourceDataSource,
                targetDataSource: targetDataSource,
            };
            return _this.splitedDataSource;
        };
        _this.moveToLeft = function () { return _this.moveTo('left'); };
        _this.moveToRight = function () { return _this.moveTo('right'); };
        _this.select = function (direction, selectedItem, checked) {
            var _a = _this.state, sourceSelectedKeys = _a.sourceSelectedKeys, targetSelectedKeys = _a.targetSelectedKeys;
            var holder = direction === 'left' ? __spread(sourceSelectedKeys) : __spread(targetSelectedKeys);
            var index = holder.indexOf(selectedItem.key);
            if (index > -1) {
                holder.splice(index, 1);
            }
            if (checked) {
                holder.push(selectedItem.key);
            }
            _this.handleSelectChange(direction, holder);
            if (_this.props.selectedKeys.length == 0) {
                _this.getSelectedKeysName(direction, holder);
            }
        };
        _this.handleLeftSelect = function (selectedItem, checked) {
            return _this.select('left', selectedItem, checked);
        };
        _this.handleRightSelect = function (selectedItem, checked) {
            return _this.select('right', selectedItem, checked);
        };
        _this.selectAll = function (direction, filteredDataSource, checkAll) {
            var holder = checkAll ? [] : filteredDataSource.map(function (item) { return item.key; });
            _this.handleSelectChange(direction, holder);
            if (_this.props.selectedKeys.length == 0) {
                _this.getSelectedKeysName(direction, holder);
            }
        };
        _this.handleLeftSelectAll = function (filteredDataSource, checkAll) {
            return _this.selectAll('left', filteredDataSource, checkAll);
        };
        _this.handleRightSelectAll = function (filteredDataSource, checkAll) {
            return _this.selectAll('right', filteredDataSource, checkAll);
        };
        _this.getSelectedKeysName = function (direction, value) {
            if (direction === 'left') {
                _this.setState({
                    sourceSelectedKeys: value,
                });
            }
            else {
                _this.setState({
                    targetSelectedKeys: value,
                });
            }
        };
        _this.checkAllCheckbox = function (props) {
            var filteredDataSource = props.filteredDataSource, checkedKeys = props.checkedKeys, handleSelectAll = props.handleSelectAll, indeterminate = props.indeterminate;
            var checkedAll = _this.getCheckStatus(filteredDataSource, checkedKeys) == 'all';
            var tmpIndeterminate = indeterminate;
            //当checkAll为true时 取消半选样式
            if (checkedAll) {
                tmpIndeterminate = false;
            }
            return (React.createElement(Checkbox, { key: "checkbox", indeterminate: tmpIndeterminate, checked: checkedAll, onChange: function () { return handleSelectAll(filteredDataSource, checkedAll); } }));
        };
        _this.title = function (props) {
            var dataSource = props.dataSource, filteredDataSource = props.filteredDataSource, checkedKeys = props.checkedKeys, handleSelectAll = props.handleSelectAll, title = props.title, indeterminate = props.indeterminate;
            return (React.createElement(DivTag, { atomics: atomicsMapTransfer.header },
                _this.checkAllCheckbox({
                    filteredDataSource: filteredDataSource,
                    checkedKeys: checkedKeys,
                    indeterminate: indeterminate,
                    handleSelectAll: handleSelectAll,
                }),
                React.createElement(SpanTag, { atomics: atomicsMapTransfer.title }, title),
                React.createElement(SpanTag, { atomics: atomicsMapTransfer.itemTotal },
                    checkedKeys.length,
                    "/",
                    dataSource.length,
                    " \u9879")));
        };
        _this.list = function (props) {
            var checkedKeys = props.checkedKeys, handleSelect = props.handleSelect, handleSelectAll = props.handleSelectAll, dataSource = props.dataSource, title = props.title, indeterminate = props.indeterminate;
            var filteredDataSource = dataSource.filter(function (item) { return !item.disabled; });
            return (React.createElement(DivTag, { atomics: atomicsMapTransfer.list },
                _this.title({
                    title: title,
                    indeterminate: indeterminate,
                    dataSource: dataSource,
                    filteredDataSource: filteredDataSource,
                    checkedKeys: checkedKeys,
                    handleSelectAll: handleSelectAll,
                }),
                React.createElement(DivTag, { atomics: atomicsMapTransfer.body },
                    React.createElement(UlTag, { atomics: atomicsMapTransfer.content }, dataSource.map(function (item) {
                        return (React.createElement(LiTag, { atomics: checkedKeys.indexOf(item.key) >= 0
                                ? item.disabled
                                    ? atomicsMapTransfer.listItemDisable
                                    : atomicsMapTransfer.listItemCheck
                                : item.disabled
                                    ? atomicsMapTransfer.listItemDisable
                                    : atomicsMapTransfer.listItem, key: "" + item.key, onClick: item.disabled
                                ? undefined
                                : function () { return handleSelect(item, !checkedKeys.some(function (key) { return key === item.key; })); } },
                            React.createElement(Checkbox, { value: item.value, checked: checkedKeys.indexOf(item.key) >= 0, disabled: item.disabled }),
                            React.createElement(SpanTag, { atomics: item.disabled
                                    ? atomicsMapTransfer.listItemTitle.concat(atomicsMapTransfer.listItemTitleDisabled)
                                    : atomicsMapTransfer.listItemTitle }, item.title)));
                    })))));
        };
        _this.operation = function (props) {
            var leftActive = props.leftActive, rightActive = props.rightActive, moveToLeft = props.moveToLeft, moveToRight = props.moveToRight;
            return (React.createElement(DivTag, { atomics: atomicsMapTransfer.operation },
                React.createElement(Button, { type: "default", size: "small", disabled: !rightActive, onClick: moveToRight, atomics: atomicsMapTransfer.btnRight, style: !rightActive
                        ? { padding: 0 }
                        : { padding: 0, backgroundColor: '#0083ff', color: '#fff', border: 'none' } },
                    React.createElement(ArrowRightOutlined, null)),
                React.createElement(Button, { type: "default", size: "small", disabled: !leftActive, onClick: moveToLeft, atomics: atomicsMapTransfer.btnLeft, style: !leftActive
                        ? { padding: 0 }
                        : { padding: 0, backgroundColor: '#0083ff', color: '#fff', border: 'none' } },
                    React.createElement(ArrowLeftOutlined, null))));
        };
        var _a = _this.splitDataSource(props), sourceDataSource = _a.sourceDataSource, targetDataSource = _a.targetDataSource;
        var selectedKeys = props.selectedKeys, targetKeys = props.targetKeys;
        _this.state = {
            sourceList: sourceDataSource,
            targetList: targetDataSource,
            sourceSelectedKeys: selectedKeys
                ? selectedKeys.filter(function (key) { return targetKeys.indexOf(key) === -1; })
                : [],
            targetSelectedKeys: selectedKeys
                ? selectedKeys.filter(function (key) { return targetKeys.indexOf(key) > 0; })
                : [],
            checkAllSrc: false,
            checkAllTar: false,
            sourceIndeterminate: false,
            targetIndeterminate: false,
        };
        return _this;
    }
    Transfer.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = this.state, sourceSelectedKeys = _a.sourceSelectedKeys, targetSelectedKeys = _a.targetSelectedKeys;
        if (nextProps.targetKeys !== this.props.targetKeys || nextProps.data !== this.props.data) {
            // clear cached splited dataSource
            this.splitedDataSource = null;
            var _b = nextProps.data, data_1 = _b === void 0 ? [] : _b, _c = nextProps.targetKeys, targetKeys_1 = _c === void 0 ? [] : _c;
            this.setState({
                sourceSelectedKeys: sourceSelectedKeys
                    .filter(function (key) {
                    return data_1.length > 0 ? data_1.some(function (item) { return item.key === key; }) : [];
                })
                    .filter(function (data) { return targetKeys_1.filter(function (key) { return key === data; }).length === 0; }),
                targetSelectedKeys: targetSelectedKeys
                    .filter(function (key) {
                    return data_1.length > 0 ? data_1.some(function (item) { return item.key === key; }) : [];
                })
                    .filter(function (data) { return targetKeys_1.filter(function (key) { return key === data; }).length > 0; }),
            });
        }
        if (nextProps.selectedKeys) {
            var targetKeys_2 = nextProps.targetKeys;
            this.setState({
                sourceSelectedKeys: nextProps.selectedKeys.filter(function (key) { return targetKeys_2.indexOf(key) === -1; }),
                targetSelectedKeys: nextProps.selectedKeys.filter(function (key) { return targetKeys_2.indexOf(key) > -1; }),
            });
        }
    };
    Transfer.prototype.moveTo = function (direction) {
        var _a = this.props, targetKeys = _a.targetKeys, onChange = _a.onChange, data = _a.data, onBeforeChange = _a.onBeforeChange;
        var _b = this.state, sourceSelectedKeys = _b.sourceSelectedKeys, targetSelectedKeys = _b.targetSelectedKeys;
        var moveKeys = direction === 'right' ? sourceSelectedKeys : targetSelectedKeys;
        // filter the disabled options
        var newMoveKeys = moveKeys.filter(function (key) {
            return !data.some(function (d) { return key === d.key && d.disabled; });
        });
        // move items to target box
        var newTargetKeys = direction === 'right'
            ? newMoveKeys.concat(targetKeys)
            : targetKeys.filter(function (targetKey) { return newMoveKeys.indexOf(targetKey) === -1; });
        // empty checked keys
        var oppositeDirection = direction === 'right' ? 'left' : 'right';
        this.getSelectedKeysName(oppositeDirection, []);
        this.handleSelectChange(oppositeDirection, []);
        if (onBeforeChange(newTargetKeys, direction, newMoveKeys)) {
            onChange(newTargetKeys, direction, newMoveKeys);
        }
    };
    Transfer.prototype.handleSelectChange = function (direction, holder) {
        var _a = this.state, sourceSelectedKeys = _a.sourceSelectedKeys, targetSelectedKeys = _a.targetSelectedKeys;
        var onSelectChange = this.props.onSelectChange;
        if (!onSelectChange) {
            return;
        }
        if (direction === 'left') {
            this.setState({
                sourceIndeterminate: holder.length !== 0,
            });
            onSelectChange(holder, targetSelectedKeys);
        }
        else {
            this.setState({
                targetIndeterminate: holder.length !== 0,
            });
            onSelectChange(sourceSelectedKeys, holder);
        }
    };
    Transfer.prototype.getCheckStatus = function (filteredDataSource, checkedKeys) {
        if (checkedKeys.length === 0) {
            return 'none';
        }
        else if (filteredDataSource.every(function (item) { return checkedKeys.indexOf(item.key) >= 0; })) {
            return 'all';
        }
        return 'part';
    };
    Transfer.prototype.render = function () {
        var _a = this.props, titles = _a.titles, style = _a.style, className = _a.className, onChange = _a.onChange, onSelectChange = _a.onSelectChange, rest = __rest(_a, ["titles", "style", "className", "onChange", "onSelectChange"]);
        var _b = this.state, sourceSelectedKeys = _b.sourceSelectedKeys, targetSelectedKeys = _b.targetSelectedKeys, sourceIndeterminate = _b.sourceIndeterminate, targetIndeterminate = _b.targetIndeterminate;
        var _c = this.splitDataSource(this.props), sourceDataSource = _c.sourceDataSource, targetDataSource = _c.targetDataSource;
        var leftActive = targetSelectedKeys.length > 0;
        var rightActive = sourceSelectedKeys.length > 0;
        return (React.createElement(DivTag, __assign({ name: Transfer.NAME, atomics: atomicsMapTransfer.transfer, className: className, style: style }, rest),
            this.list({
                title: titles[0],
                dataSource: sourceDataSource,
                checkedKeys: sourceSelectedKeys,
                indeterminate: sourceIndeterminate,
                handleSelect: this.handleLeftSelect,
                handleSelectAll: this.handleLeftSelectAll,
            }),
            this.operation({
                leftActive: leftActive,
                rightActive: rightActive,
                moveToLeft: this.moveToLeft,
                moveToRight: this.moveToRight,
            }),
            this.list({
                title: titles[1],
                dataSource: targetDataSource,
                checkedKeys: targetSelectedKeys,
                indeterminate: targetIndeterminate,
                handleSelect: this.handleRightSelect,
                handleSelectAll: this.handleRightSelectAll,
            })));
    };
    Transfer.defaultProps = defaultProps;
    Transfer.NAME = 'transfer';
    Transfer.displayName = 'Transfer';
    return Transfer;
}(PureComponent));
export { Transfer };
